import { Injectable } from '@angular/core';
import { generalHelpers } from '@mzima-client/sdk';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private countrySubject = new BehaviorSubject<string | null>(
    localStorage.getItem(`${generalHelpers.CONST.LOCAL_STORAGE_PREFIX}userCountry`),
  );
  country$ = this.countrySubject.asObservable();

  getCountryCode(): string | null {
    return this.countrySubject.value;
  }

  setCountryCode(value: string) {
    localStorage.setItem(`${generalHelpers.CONST.LOCAL_STORAGE_PREFIX}userCountry`, value);
    this.countrySubject.next(value);
  }
}
